module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//1.jpg?915394131089115565f8db51e04a3212";